import { BASE_URL } from "config";

export const endpoints = {
    upload: `${BASE_URL}/api/v1/file/upload/`,
};
